import { getCurrentDonor, getToken, loginAdmin } from "appState/auth/authSlice";
import LoginFrame from "assets/images/jpgs/loginframe.jpg";
import { TKIconEye, TKIconSpinner, TKIconViewEye } from "assets/images/svgs";
import { useFormik } from "formik";
import RequestConfirmation from "layout/modal/RequestConfirmation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "shared/CompanyLogo";
import InputField from "shared/InputField";

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setshowForgotPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();
  const { isLoading, isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    isAuthenticated && navigate("/");
  }, [isAuthenticated, navigate]);

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (values) => {
      const body = {
        email: values.email,
        password: values.password,
      };
      dispatch(loginAdmin(body)).then((data) => {
        const { payload } = data;
        if (payload?.status === 200) {
          dispatch(getToken(payload));
          dispatch(getCurrentDonor()).then(() => {
            let path = "/donor";
            navigate(path);
          });
        }
      });
    },
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <RequestConfirmation
        text="Are you sure you want to reset your password?"
        isOpen={showForgotPassword}
        onClose={() => setshowForgotPassword(false)}
      />
      <div className="w-full h-full flex max-md:flex-wrap items-center gap-8">
        <div className="relative w-[60%] max-md:w-full max-md:h-[500px] h-screen">
          <img
            className="w-full h-full object-cover"
            src={LoginFrame}
            alt="TK-LoginFrame"
          />
          <p className="px-8 absolute bottom-10 max-md:text-[14px] text-[28px] text-white font-semibold shadow-md">
            Speak up for those who cannot speak for themselves, for the rights
            of all who are destitute. Speak up and judge fairly; defend the
            rights of the poor and needy.
          </p>
        </div>
        <div className="px-4 w-[40%] max-md:w-full flex flex-col justify-center items-start gap-4">
          <div className="mb-4">
            <CompanyLogo blue />
          </div>
          <div className="mb-2 w-full">
            <p className="text-[20px] font-bold mb-2">Login as an admin</p>
          </div>
          <form onSubmit={formik.handleSubmit} className="w-full">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-[14px] font-normal">Email Address</label>
                <InputField
                  className="border border-[#E6E6E6] rounded-md"
                  type="text"
                  name="email"
                  placeholder="exampleforyou@info.com"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
              </div>
              <div className="relative flex flex-col gap-2">
                <label className="text-[14px] font-normal">Password</label>
                <InputField
                  className="border border-[#E6E6E6] rounded-md"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="************"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
                {showPassword ? (
                  <TKIconViewEye
                    onClick={toggleShowPassword}
                    className="absolute w-4 right-4 top-[43px] z-2 hover:cursor-pointer"
                  />
                ) : (
                  <TKIconEye
                    onClick={toggleShowPassword}
                    className="absolute w-4 right-4 top-[43px] z-2 hover:cursor-pointer"
                  />
                )}
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full h-[50px] rounded-lg bg-[#213874] hover:bg-[#182d62] px-4 py-2 flex items-center justify-center"
                >
                  <p className="text-white font-semibold">
                    {isLoading ? <TKIconSpinner /> : "Login"}
                  </p>
                </button>
                <div className="flex justify-between my-4">
                  <label className="flex gap-2">
                    <input type="checkbox" name="rememberMe" />
                    <p className="text-[#F57200]">Remember me</p>
                  </label>
                  <p
                    onClick={() => navigate("/auth/forgot-password")}
                    className="text-[#F57200] hover:text-[#f57200a5]"
                  >
                    Forgot password?
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
